import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-chip',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="">
            <div
                class="px-4 py-1 rounded text-[11px] font-semibold uppercase tracking-wide text-center truncate whitespace-nowrap w-56"
                [style.background-color]="backgroundColor"
                [style.color]="textColor">
                {{ text }}
            </div>
        </div>
    `,
})
export class ChipComponent {
    @Input() text: string = '';
    @Input() backgroundColor: string = '#737373';
    @Input() textColor: string = '#FFFFFF';
}
